module.exports = {"controllers":{"ask_to_delete_category":{"title":"Are you sure?","content":"Please confirm that you want to delete category:<br><strong>{{category_name}}</strong>","confirm":"Yes, delete","cancel":"Cancel"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/categories.json
// module id = 2389
// module chunks = 1